import React from "react";
interface Props {
	title: string;
	className?: string;
	children?: React.ReactNode;
	sticky?: boolean;
	scroll?: boolean;
	style?: { [key: string]: string | number | null };
}

function PageHeader({
	title,
	children,
	className = "",
	sticky = false,
	scroll = false,
	style,
}: Props) {
	return (
		<header
			className={`title-container ${sticky ? "sticky-top " : ""} ${
				scroll ? "scroll__active" : ""
			}`}>
			<div className={`page-header ${className}`} style={style}>
				<div className="title-container">
					<h1>{title}</h1>
				</div>
				{children}
			</div>
		</header>
	);
}

export default PageHeader;
